import CheckIcon from './component'

export default CheckIcon
